<!-- https://primefaces.org/primeng/showcase/#/setup -->

<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top-off" style="background-color: #ffffff">
	<!-- 		 	     -->
	<!-- Person Selector -->
	<!-- 			 	 -->
	<div>
		<caass-personselector
			[AudienceID]="1"
			[CanSwitchAudience]="false"
			[ShowAllSchools]="false"
			[MultiSelect]="false"
			[buttonMultiSelectProcessCaption]="'Add'"
		></caass-personselector>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()" [disabled]="IsExpressSchool == false">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()" [disabled]="isBusy == true || IsExpressSchool == false">Add</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()" [disabled]="isBusy == true || IsExpressSchool == false">Remove</button>
		<button
			class="btn btn-success"
			style="margin-left: 5px"
			(click)="onPrint()"
			[disabled]="isBusy == true || lstPrintQueue.length == 0 || IsExpressSchool == false"
		>
			Print Cards
		</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />

		<div class="table-deadline-data" [style.display]="IsExpressSchool == true ? 'flex' : 'none'">
			<div>Print Submit Deadline Time:</div>
			<div class="table-totals-counts">
				{{ SubmitCutoffTime | date : "shortTime" }}
			</div>
		</div>

		<div class="table-deadline-data" [style.display]="IsExpressSchool == false ? 'flex' : 'none'">
			<div style="color: #e61010">Current School Is Not An Express School</div>
		</div>
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Total items in express queue: {{ lstPrintQueue.length }}</label
		><br />
		<label>&#9900; Total items selected in express queue: {{ lstPrintQueueChecked.length }}</label
		><br />
		<label>&#9900; Remove will remove only the selected items from the express queue.</label><br />
		<label>&#9900; Print will print all the items in the express queue.</label><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		<label>&#9900; Default sort order for express queue is LastName, FirstName</label><br />
		<label>&#9900; Default sort order for Last 30 Days list is Status Date with Print Pending first.</label><br />
	</div>
</div>

<!-- 			  -->
<!-- Total Counts -->
<!-- 			  -->
<div class="table-totals-body">
	<div class="table-totals-data" style="margin-left: 0px">
		<div>Print pending:</div>
		<div class="table-totals-counts">{{ SchoolTotalSubmitted }}</div>
	</div>

	<div class="table-totals-data">
		<div>Today printed:</div>
		<div class="table-totals-counts">{{ SchoolPrintedToday }}</div>
	</div>

	<div class="table-totals-data">
		<div>Total printed:</div>
		<div class="table-totals-counts">{{ SchoolTotalPrinted }}</div>
	</div>
</div>

<!-- 					  -->
<!-- Display PrintQ Items -->
<!-- 					  -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->
	<p-table
		#mydt
		[value]="lstPrintQueue"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		[(selection)]="lstPrintQueueChecked"
		[rowHover]="true"
		dataKey="IDDepotPrintQueueID"
		(onSort)="onHandleSort($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50, 100]"
	>
		<ng-template pTemplate="header">
			<tr>
				<th style="width: 3rem">
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="StudentID">StudentID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th pSortableColumn="HasPhoto" class="fixwidth-07">Photo<p-sortIcon field="HasPhoto"></p-sortIcon></th>
				<th pSortableColumn="LastName">Full Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="AddedDT">Submit Pending<p-sortIcon field="AddedDT"></p-sortIcon></th>
				<th pSortableColumn="IDDepotPrintReasonDesc">Print Reason<p-sortIcon field="IDDepotPrintReasonDesc"></p-sortIcon></th>
				<th pSortableColumn="IsMTAOverride">{{ PublicTransitLabel }} Override<p-sortIcon field="IsMTAOverride"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rPrintQueueItem>
			<tr [pSelectableRow]="rPrintQueueItem">
				<td>
					<div>
						<p-tableCheckbox [value]="rPrintQueueItem"></p-tableCheckbox>
					</div>
				</td>

				<td>
					<div>{{ rPrintQueueItem.StudentID }}</div>
				</td>

				<td>
					<div class="fixwidth-07">
						<i
							class="pi"
							[ngClass]="{
								'pi-check-circle table-has-photo-check': rPrintQueueItem.HasPhoto,
								'pi-ban table-no-photo-check': !rPrintQueueItem.HasPhoto
							}"
						></i>
					</div>
				</td>

				<td>
					<div>
						{{ rPrintQueueItem.FirstName }}
						{{ rPrintQueueItem.LastName }}
					</div>
				</td>

				<td>
					<div>
						{{ rPrintQueueItem.AddedDTDesc }}
					</div>
				</td>

				<td>
					<div>
						{{ rPrintQueueItem.IDDepotPrintReasonDesc }}
					</div>
				</td>

				<td>
					<div>
						{{ rPrintQueueItem.IsMTAOverrideDesc }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						 -->
<!-- Display When No Q Items -->
<!-- 					     -->
<div style="padding: 20px" [style.display]="lstPrintQueue.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No items to print...</label>
</div>

<!-- 			  -->
<!-- Total Counts -->
<!-- 			  -->
<div class="table-totals-history-body">
	<div style="margin: 0 auto">Last 30 Days Of Printed Cards</div>
</div>

<!-- 					  -->
<!-- Display PrintQ History Items -->
<!-- 					  -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->
	<p-table
		#mydthist
		[value]="lstPrintQueueHistory"
		[paginator]="true"
		[(rows)]="historypagerows"
		[(first)]="historypagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		(onSort)="onHandleHistorySort($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50, 100]"
	>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="StudentID">StudentID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th pSortableColumn="HasPhoto" class="fixwidth-07">Photo<p-sortIcon field="HasPhoto"></p-sortIcon></th>
				<th pSortableColumn="LastName">Full Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="StatusDT">Status Date<p-sortIcon field="StatusDT"></p-sortIcon></th>
				<th pSortableColumn="IDDepotPrintQueueStatusDesc">Status<p-sortIcon field="IDDepotPrintQueueStatusDesc"></p-sortIcon></th>
				<th pSortableColumn="IDDepotPrintReasonDesc">Print Reason<p-sortIcon field="IDDepotPrintReasonDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rPrintQueueHistoryItem>
			<tr>
				<td>
					<div>{{ rPrintQueueHistoryItem.StudentID }}</div>
				</td>

				<td>
					<div class="fixwidth-07">
						<i
							class="pi"
							[ngClass]="{
								'pi-check-circle table-has-photo-check': rPrintQueueHistoryItem.HasPhoto,
								'pi-ban table-no-photo-check': !rPrintQueueHistoryItem.HasPhoto
							}"
						></i>
					</div>
				</td>

				<td>
					<div>
						{{ rPrintQueueHistoryItem.FirstName }}
						{{ rPrintQueueHistoryItem.LastName }}
					</div>
				</td>

				<td>
					<div>
						{{ rPrintQueueHistoryItem.StatusDTDesc }}
					</div>
				</td>

				<td>
					<div
						[ngClass]="{
							'table-data-status-1': rPrintQueueHistoryItem.IDDepotPrintQueueStatusID == 1,
							'table-data-status-2': rPrintQueueHistoryItem.IDDepotPrintQueueStatusID == 2,
							'table-data-status-3': rPrintQueueHistoryItem.IDDepotPrintQueueStatusID == 3,
							'table-data-status-4': rPrintQueueHistoryItem.IDDepotPrintQueueStatusID == 4,
							'table-data-status-5': rPrintQueueHistoryItem.IDDepotPrintQueueStatusID == 5
						}"
					>
						{{ rPrintQueueHistoryItem.IDDepotPrintQueueStatusDesc }}
					</div>
				</td>

				<td>
					<div>
						{{ rPrintQueueHistoryItem.IDDepotPrintReasonDesc }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 								-->
<!-- Display When No HistoryQ Items -->
<!--		 					    -->
<div style="padding: 20px" [style.display]="lstPrintQueueHistory.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No items to printed...</label>
</div>
